import { useState, useEffect } from "react";
import "./PdfViewerModal.css";

function getDocLabel(index) {
    return `Document ${index + 1}`;
}

function PdfViewerModal({ urls, onClose }) {
    const [selectedIndex, setSelectedIndex] = useState(0);

    useEffect(() => {
        const handleKey = (e) => {
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKey);
        return () => document.removeEventListener("keydown", handleKey);
    }, [onClose]);

    const currentUrl = urls[selectedIndex] || null;

    return (
        <div className="pdf-modal-overlay" onClick={onClose}>
            <div className="pdf-modal-panel" onClick={(e) => e.stopPropagation()}>
                <div className="pdf-modal-header">
                    <h3>Documents</h3>
                    <button className="pdf-modal-close" onClick={onClose} aria-label="Close">
                        ✕
                    </button>
                </div>

                <div className="pdf-modal-body">
                    <div className="pdf-modal-sidebar">
                        {urls.map((url, i) => (
                            <div
                                key={i}
                                className={`pdf-modal-doc-item${selectedIndex === i ? " active" : ""}`}
                                onClick={() => setSelectedIndex(i)}
                            >
                                <div className="pdf-modal-doc-label">
                                    <span>{getDocLabel(i)}</span>
                                </div>
                                {url && (
                                    <a
                                        href={url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="pdf-modal-new-tab"
                                        onClick={(e) => e.stopPropagation()}
                                        title="Open in new tab"
                                    >
                                        ↗
                                    </a>
                                )}
                            </div>
                        ))}
                    </div>

                    <div className="pdf-modal-viewer">
                        {currentUrl ? (
                            <iframe src={currentUrl} title={getDocLabel(selectedIndex)} />
                        ) : (
                            <span className="pdf-modal-no-doc">No document available</span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PdfViewerModal;
